import { render, staticRenderFns } from "./EvaluationWrapper.vue?vue&type=template&id=510d5850&"
import script from "./EvaluationWrapper.vue?vue&type=script&lang=js&"
export * from "./EvaluationWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports